import { useTranslation } from 'react-i18next';
import './SuggestedQueries.css';

interface SuggestedQueriesProps {
  onQueryClick: (query: string) => void;
}

const SUGGESTION_ICONS = [
  // Ratings — star icon
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>,
  // Compare — bar chart icon
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" /></svg>,
  // Methodology — book icon
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 016.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" /></svg>,
  // Analytics — trending up icon
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" /></svg>,
];

export default function SuggestedQueries({ onQueryClick }: SuggestedQueriesProps) {
  const { t } = useTranslation();

  const suggestions = [
    { key: 'ratings', query: t('agents.suggestion1') },
    { key: 'compare', query: t('agents.suggestion2') },
    { key: 'methodology', query: t('agents.suggestion3') },
    { key: 'analytics', query: t('agents.suggestion4') },
  ];

  return (
    <div className="suggested-queries">
      <div className="query-cards">
        {suggestions.map((suggestion, idx) => (
          <button
            key={suggestion.key}
            className="query-card"
            onClick={() => onQueryClick(suggestion.query)}
          >
            <span className="query-card-icon">{SUGGESTION_ICONS[idx]}</span>
            <span className="query-card-text">{suggestion.query}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
